import { useState } from 'react';

import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import { withStyles } from '@material-ui/core/styles';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import styles from './AccordionOption.module.scss';
import jsStyles from './styles';

const CustomAccordion = withStyles(jsStyles.accordion)(Accordion);
const CustomAccordionSummary = withStyles(jsStyles.summary)(AccordionSummary);
const CustomAccordionDetails = withStyles(jsStyles.details)(AccordionDetails);

function AccordionOption({ placeholder, selected, onClick, small, data }) {
  const [isExpanded, setIsExpanded] = useState(false);
  let header = <span className={styles.header}>{placeholder}</span>;
  if (selected) {
    header = [
      <span key={0} className={styles.header}>
        {selected.text}
      </span>,
      // (map) ? <span key={1} className={styles.header__wsType}>{selected.type}</span> : null
    ];
  }

  const handleSelectedItem = (item) => {
    setIsExpanded(false);
    onClick(item);
  };

  const handleAccordionChange = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div style={jsStyles.container}>
      <span></span>
      <CustomAccordion
        id="accordion"
        onChange={handleAccordionChange}
        expanded={isExpanded}
      >
        <CustomAccordionSummary
          expandIcon={
            <ExpandMoreIcon style={{ fill: 'var(--color-main-orange)' }} />
          }
        >
          <div className={styles.option__container}>{header}</div>
        </CustomAccordionSummary>
        <CustomAccordionDetails>
          <div
            className={
              small ? styles.listContainer_small : styles.listContainer
            }
          >
            {data.map((item) => {
              return (
                <div
                  key={item.value}
                  className={styles.option__container}
                  onClick={() => handleSelectedItem(item)}
                >
                  <div className={styles.option__text}>{item.text}</div>
                  {/* <div className={styles.option__wsType}>{(map)? item.type : null}</div> */}
                </div>
              );
            })}
          </div>
        </CustomAccordionDetails>
        <div style={{ height: '10px', marginBottom: '-10px' }}></div>
      </CustomAccordion>
      <span></span>
    </div>
  );
}

export default AccordionOption;
